module.exports = __webpack_public_path__ + "static/media/sba.0d3a88f9.png";